import styled, { keyframes } from "styled-components";

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 0.6; transform: scale(1); }
  50%      { opacity: 1;   transform: scale(1.05); }
`;

const girar = keyframes`
  to { transform: rotate(360deg); }
`;

/* Mesmo fundo da tela de login: as duas são páginas públicas e avulsas. */
export const Wrapper = styled.div`
  background: linear-gradient(135deg, #024995 0%, #009bd9 60%, #024995 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  padding: 40px 20px;
  box-sizing: border-box;
  color: #fff;
  position: relative;
  overflow-x: hidden;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image:
      linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px);
    background-size: 50px 50px;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    top: -120px;
    right: -120px;
    width: 400px;
    height: 400px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(0,155,217,0.45) 0%, transparent 70%);
    pointer-events: none;
    animation: ${pulse} 5s ease-in-out infinite;
  }

  img.logo {
    max-width: 200px;
    margin-bottom: 26px;
    filter: drop-shadow(0 8px 24px rgba(0,0,0,0.3));
    position: relative;
    z-index: 1;
  }
`;

export const Card = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 520px;
  color: #024995;
  border-radius: 24px;
  padding: 40px 36px 32px;
  text-align: center;
  box-shadow: 0 32px 80px rgba(2, 73, 149, 0.25), 0 8px 24px rgba(0, 0, 0, 0.1);
  animation: ${fadeInUp} 0.6s ease-out both;
  position: relative;
  z-index: 1;
  box-sizing: border-box;

  h1 {
    font-size: 24px;
    margin: 0 0 10px 0;
    text-transform: uppercase;
    font-weight: 800;
    letter-spacing: 2px;
    background: linear-gradient(135deg, #024995 0%, #009bd9 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

export const Subtitulo = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #7a8fa6;
  margin: 0 0 24px;
`;

/* Bloco com nome do aluno/turma, para o responsável conferir antes de enviar. */
export const Identificacao = styled.div`
  background: #f5f8fc;
  border: 1px solid #e8eef5;
  border-radius: 14px;
  padding: 16px 20px;
  margin-bottom: 24px;
  text-align: left;

  dl {
    margin: 0;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 6px 14px;
  }

  dt {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #7a8fa6;
    white-space: nowrap;
    align-self: center;
  }

  dd {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: #1a2740;
    word-break: break-word;
  }
`;

/* Área de seleção do arquivo. Vira um <label> para o clique abrir o input escondido. */
export const Dropzone = styled.label<{ $ativo?: boolean; $temArquivo?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border: 2px dashed
    ${(p) => (p.$ativo ? "#009bd9" : p.$temArquivo ? "#1b7a4b" : "#cdd9e6")};
  background: ${(p) =>
    p.$ativo ? "rgba(0,155,217,0.08)" : p.$temArquivo ? "#eafaf1" : "#f9fbfd"};
  border-radius: 16px;
  padding: 30px 20px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-align: center;

  &:hover {
    border-color: #009bd9;
    background: rgba(0, 155, 217, 0.06);
  }

  svg {
    color: ${(p) => (p.$temArquivo ? "#1b7a4b" : "#009bd9")};
  }

  strong {
    font-size: 15px;
    color: #1a2740;
    word-break: break-all;
  }

  span {
    font-size: 12.5px;
    color: #7a8fa6;
  }

  input {
    display: none;
  }
`;

export const Botao = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #f39200 0%, #ffb347 100%);
  color: #fff;
  border: none;
  padding: 15px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: 20px;
  transition: all 0.3s ease;
  font-family: inherit;
  box-shadow: 0 6px 20px rgba(243, 146, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 28px rgba(243, 146, 0, 0.5);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

export const Spinner = styled.span`
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ${girar} 0.7s linear infinite;
  display: inline-block;
`;

export const Aviso = styled.p`
  background: #fff4e5;
  border: 1px solid #ffd8a8;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.5;
  color: #a35b00;
  margin: 18px 0 0;
  text-align: center;
  animation: ${fadeInUp} 0.3s ease-out both;
`;

/* Painel de estado final (sucesso, em análise, aprovado, link inválido). */
export const Painel = styled.div<{ $tom: "sucesso" | "info" | "erro" }>`
  background: ${(p) =>
    p.$tom === "sucesso" ? "#eafaf1" : p.$tom === "erro" ? "#fdecec" : "#eef6fd"};
  border: 1px solid
    ${(p) =>
      p.$tom === "sucesso" ? "#b7e4c7" : p.$tom === "erro" ? "#f5c2c2" : "#c5e0f7"};
  border-radius: 16px;
  padding: 24px 22px;
  color: ${(p) =>
    p.$tom === "sucesso" ? "#1b7a4b" : p.$tom === "erro" ? "#a12727" : "#0b5a92"};
  animation: ${fadeInUp} 0.4s ease-out both;

  .icone {
    font-size: 34px;
    line-height: 1;
    margin-bottom: 10px;
  }

  strong {
    display: block;
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 8px;
  }

  p {
    margin: 0;
    font-size: 14px;
    line-height: 1.6;
  }
`;

export const Rodape = styled.p`
  font-size: 12.5px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.75);
  text-align: center;
  margin: 22px 0 0;
  max-width: 520px;
  position: relative;
  z-index: 1;
`;

/* Estado de carregamento inicial, antes de saber se o token vale. */
export const Carregando = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #fff;
  position: relative;
  z-index: 1;

  span.roda {
    width: 38px;
    height: 38px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: ${girar} 0.8s linear infinite;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.85);
  }
`;
